var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuStatsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 94,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 44a3 3 0 0 1 3-3h19.2a3 3 0 0 1 3 3v34.7H5.3V44ZM68.4 27.3a3 3 0 0 1 3-3h19.3a3 3 0 0 1 3 3v51.4H68.4V27.3ZM36.8 3.3a3 3 0 0 1 3-3h19.3a3 3 0 0 1 3 3v75.4H36.8V3.3Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 83.9,
    width: 100,
    height: 9.4,
    rx: 4.7,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStatsIcon);
export default __webpack_public_path__ + "static/media/menu-stats-icon.2392da866670da414fd459e6e23cef79.svg";
export { ForwardRef as ReactComponent };